import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import translations from '@nike/gameday-translations/web';

import Flag from '~COMPONENTS/flag/Flag';
import { TranslatedCopy } from '../../../intl/TranslatedCopy';

import {
  getCountryCodeName,
  getCountryCodeLanguage,
  COUNTRY_CODE_CHINA,
  LOCALE_SIMPLIFIED_CHINESE,
  LOCALE_TRADITIONAL_CHINESE
} from '../constants';

export const LanguagePickerCardLanguage = ({ onClick, selected, data: { countryCode, locale } }) => {
  const onClickHandler = () => {
    if (onClick) onClick(countryCode, locale);
  };

  const { en } = translations;
  const dataE2E = en[getCountryCodeName(countryCode)]?.replace(/ /g, '-')?.toLowerCase();

  return (
    <>
      {countryCode === COUNTRY_CODE_CHINA ? (
        <div
          data-e2e={dataE2E}
          className={classnames('flex-container row pt2-sm pb2-sm prl4-sm m3-sm align-center', {
            'border-medium-grey': selected
          })}
          style={{ opacity: 1, flexDirection: 'column' }}
        >
          <div style={{ display: 'flex' }}>
            <div className='pr1-sm'>
              <Flag countryCode={countryCode} />
            </div>
            <span>{new TranslatedCopy({ id: getCountryCodeName(countryCode) }).toString(locale.split('_')[0])}</span>
          </div>

          <div>
            <span
              onClick={() => onClick(countryCode, LOCALE_SIMPLIFIED_CHINESE)}
              style={{ paddingRight: '10px', cursor: 'pointer' }}
            >
              {new TranslatedCopy({ id: 'languagePicker.lang.simplifiedChinese' }).toString('cn')}
            </span>
            <span
              onClick={() => onClick(countryCode, LOCALE_TRADITIONAL_CHINESE)}
              style={{ paddingLeft: '10px', cursor: 'pointer' }}
            >
              {new TranslatedCopy({ id: 'languagePicker.lang.traditionalChinese' }).toString('tc')}
            </span>
          </div>
        </div>
      ) : (
        <div
          data-e2e={dataE2E}
          className={classnames('flex-container row pt2-sm pb2-sm prl4-sm m3-sm selectable align-center', {
            'border-medium-grey': selected
          })}
          style={{ opacity: 1, flexDirection: 'column' }}
          onClick={onClickHandler}
        >
          <div style={{ display: 'flex' }}>
            <div className='pr1-sm'>
              <Flag countryCode={countryCode} />
            </div>
            <span>{new TranslatedCopy({ id: getCountryCodeName(countryCode) }).toString(locale.split('_')[0])}</span>
          </div>
          <span>{new TranslatedCopy({ id: getCountryCodeLanguage(countryCode) }).toString(locale.split('_')[0])}</span>
        </div>
      )}
    </>
  );
};

LanguagePickerCardLanguage.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    countryCode: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    locale: PropTypes.string
  }).isRequired
};

export default LanguagePickerCardLanguage;
